import InteractiveHouse from './InteractiveHouse';

export { InteractiveHouse };
